// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.react-modal-overlay {
  background-color: rgba(0, 0, 0, 0.75);
  /* optional, provides a darker background outside the modal */
  position: fixed;
  /* This ensures the overlay covers the whole screen */
  top: 0;
  left: 0;
  right: 0;
  bottom: 0;
  display: flex;
  justify-content: center;
  align-items: center;
  z-index: 1000;
  /* This ensures the overlay is above all other elements */
}

.react-modal-content {
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: space-between;
  background-color: rgb(50, 10, 131);
  color: white;
  max-width: 50%;
  max-height: 60%;
  width: 100%;
  padding: 20px;
  overflow: auto;
  position: relative;
  z-index: 1000;
  /* This ensures the modal is above all other elements */
  border-radius: 20px;
}

.react-modal-content textarea {
  width: 100%;
  margin-top: 10px;
  background-color: rgba(0, 0, 0, 0.5);
  color: white; /* white text */
}

.react-modal-content textarea,
.react-modal-content button {
  margin-top: 10px;
  display: block;
}

.react-modal-content .button-row {
  display: flex;
  justify-content: flex-start;
  gap: 10px;
  margin-top: 10px;
}

.button_container {
  display: flex;
  justify-content: flex-end;
  gap: 10px;
  width: 100%;
  padding-right: 5%;
}
`, "",{"version":3,"sources":["webpack://./src/components/Feedback/style.css"],"names":[],"mappings":"AAAA;EACE,qCAAqC;EACrC,6DAA6D;EAC7D,eAAe;EACf,qDAAqD;EACrD,MAAM;EACN,OAAO;EACP,QAAQ;EACR,SAAS;EACT,aAAa;EACb,uBAAuB;EACvB,mBAAmB;EACnB,aAAa;EACb,yDAAyD;AAC3D;;AAEA;EACE,aAAa;EACb,sBAAsB;EACtB,mBAAmB;EACnB,8BAA8B;EAC9B,kCAAkC;EAClC,YAAY;EACZ,cAAc;EACd,eAAe;EACf,WAAW;EACX,aAAa;EACb,cAAc;EACd,kBAAkB;EAClB,aAAa;EACb,uDAAuD;EACvD,mBAAmB;AACrB;;AAEA;EACE,WAAW;EACX,gBAAgB;EAChB,oCAAoC;EACpC,YAAY,EAAE,eAAe;AAC/B;;AAEA;;EAEE,gBAAgB;EAChB,cAAc;AAChB;;AAEA;EACE,aAAa;EACb,2BAA2B;EAC3B,SAAS;EACT,gBAAgB;AAClB;;AAEA;EACE,aAAa;EACb,yBAAyB;EACzB,SAAS;EACT,WAAW;EACX,iBAAiB;AACnB","sourcesContent":[".react-modal-overlay {\n  background-color: rgba(0, 0, 0, 0.75);\n  /* optional, provides a darker background outside the modal */\n  position: fixed;\n  /* This ensures the overlay covers the whole screen */\n  top: 0;\n  left: 0;\n  right: 0;\n  bottom: 0;\n  display: flex;\n  justify-content: center;\n  align-items: center;\n  z-index: 1000;\n  /* This ensures the overlay is above all other elements */\n}\n\n.react-modal-content {\n  display: flex;\n  flex-direction: column;\n  align-items: center;\n  justify-content: space-between;\n  background-color: rgb(50, 10, 131);\n  color: white;\n  max-width: 50%;\n  max-height: 60%;\n  width: 100%;\n  padding: 20px;\n  overflow: auto;\n  position: relative;\n  z-index: 1000;\n  /* This ensures the modal is above all other elements */\n  border-radius: 20px;\n}\n\n.react-modal-content textarea {\n  width: 100%;\n  margin-top: 10px;\n  background-color: rgba(0, 0, 0, 0.5);\n  color: white; /* white text */\n}\n\n.react-modal-content textarea,\n.react-modal-content button {\n  margin-top: 10px;\n  display: block;\n}\n\n.react-modal-content .button-row {\n  display: flex;\n  justify-content: flex-start;\n  gap: 10px;\n  margin-top: 10px;\n}\n\n.button_container {\n  display: flex;\n  justify-content: flex-end;\n  gap: 10px;\n  width: 100%;\n  padding-right: 5%;\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
